import { render, staticRenderFns } from "./m_AllCustomers.vue?vue&type=template&id=1bfd5ca8&scoped=true&"
import script from "./m_AllCustomers.vue?vue&type=script&lang=js&"
export * from "./m_AllCustomers.vue?vue&type=script&lang=js&"
import style0 from "./m_AllCustomers.vue?vue&type=style&index=0&id=1bfd5ca8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd5ca8",
  null
  
)

export default component.exports